import { Outlet } from "react-router-dom";
import { useState } from "react";
import { TopHeader } from "@/components/layout/TopHeader";
import { Sidebar } from "@/components/layout/Sidebar";
import { NewDocumentModal } from "@/components/NewDocumentModal";
import { Sheet, SheetContent, SheetTitle } from "@/components/ui/sheet";
import { VisuallyHidden } from "@radix-ui/react-visually-hidden";
import { useAuth } from "@/context/AuthContext";
import { FlaskConical } from "lucide-react";

export function DashboardLayout() {
  const { organization } = useAuth();
  const [modalOpen, setModalOpen] = useState(false);
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const bumpRefresh = () => setRefreshKey((k) => k + 1);

  return (
    <div className="min-h-screen bg-slate-50">
      <TopHeader onNewDocument={() => setModalOpen(true)} onToggleMobileSidebar={() => setMobileSidebarOpen(true)} />
      {organization?.is_demo && (
        <div
          className="bg-amber-400 text-amber-950 text-xs sm:text-sm font-medium text-center py-1.5 px-3 flex items-center justify-center gap-1.5"
          data-testid="demo-mode-banner"
        >
          <FlaskConical className="w-3.5 h-3.5 shrink-0" />
          Демо-режим — это общий тестовый кабинет, данные видны всем посетителям демо
        </div>
      )}
      <div className="flex">
        <Sidebar onNewDocument={() => setModalOpen(true)} refreshKey={refreshKey} />
        <Sheet open={mobileSidebarOpen} onOpenChange={setMobileSidebarOpen}>
          <SheetContent side="left" className="p-0 w-64" data-testid="mobile-sidebar-sheet">
            <VisuallyHidden asChild>
              <SheetTitle>Навигация</SheetTitle>
            </VisuallyHidden>
            <Sidebar mobile onNewDocument={() => setModalOpen(true)} refreshKey={refreshKey} onNavigate={() => setMobileSidebarOpen(false)} />
          </SheetContent>
        </Sheet>
        <main className="flex-1 p-4 sm:p-6 min-w-0">
          <Outlet context={{ openNewDocument: () => setModalOpen(true), bumpRefresh }} />
        </main>
      </div>
      <NewDocumentModal open={modalOpen} onOpenChange={setModalOpen} onCreated={bumpRefresh} />
    </div>
  );
}
